module.exports = __webpack_public_path__ + "static/money-6cafaa69843b3321621a62faea574d45.jpg";